import _isPlainObject from 'lodash/isPlainObject';
import assert from 'http-assert-plus';
import * as filters from '@src/filters';
import * as fontAwesomeIcons from './fontAwesome';
import { preparePageClick, capturePageClick } from '@src/lib/logs';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(...Object.keys(fontAwesomeIcons).reduce((icons, key) => icons.concat(fontAwesomeIcons[key]), []));

export default function configure(Vue) {
  if (configure.installed) {
    // Immediately return if this method has previously executed
    return;
  } else {
    configure.installed = true;
  }

  Vue.prototype.$assert = assert.create();

  for (const key in filters) {
    if (filters.hasOwnProperty(key)) {
      const { [key]: filter } = filters;
      Vue.filter(key, filter);
    }
  }

  Vue.component('empty-slot', {
    name: 'EmptySlot',
    functional: true,
    render: (h, { data }) => h('template', data, ''),
  });

  Vue.directive('cy', {
    bind(el, binding, vnode) {
      const { rawName, name, value } = binding || {};
      const { $root } = vnode.context || {};
      const { isCypress, origin } = $root || {};

      if (isCypress || `${origin}`.startsWith('http://localhost:')) {
        const attr = `data-cy${rawName.includes(':') ? rawName.substr(name.length + 3) : ''}`;
        Vue.$log.debug(rawName, { origin, $root, rawName, value });

        if (_isPlainObject(value) || Array.isArray(value)) {
          el.setAttribute(attr, JSON.stringify(value));
        } else if (value !== null && value !== undefined) {
          el.setAttribute(attr, `${value}`);
        }
      }
    },
  });

  Vue.directive('page-click', {
    bind(el, binding, vnode) {
      // Vue.$log.debug({ el, data, vnode });
      const data = preparePageClick(el, binding, vnode);
      el.addEventListener('click', () => Promise.resolve(capturePageClick(data)).catch(err => Vue.$log.error(err)));
    },
  });

  Vue.component('no-ssr', {
    name: 'No-SSR',
    functional: true,
    props: {
      placeholder: String,
    },
    render(h, { parent, slots, props }) {
      const { default: defaultSlot = [], placeholder: placeholderSlot } = slots();

      if (process.env.VUE_ENV === 'client') {
        if (parent._isMounted) {
          return defaultSlot;
        }

        parent.$once('hook:mounted', () => parent.$forceUpdate());
      }

      if (props.placeholder || placeholderSlot) {
        return h('div', { class: [ 'no-ssr-placeholder' ] }, props.placeholder || placeholderSlot);
      }

      // Return a placeholder element for each child in the default slot
      // Or if no children return a single placeholder
      return defaultSlot.length > 0 ? defaultSlot.map(() => h(false)) : h(false);
    },
  });
};



// WEBPACK FOOTER //
// ./src/configure.js